import { localize } from "render/context/InternationalizationContext";

export const Trans = {
  ChaptersComplete: localize<{ current: number; total: number }>({
    en_GB: ({ current, total }) => `${current}/${total} chapters complete`,
    sv_SE: ({ current, total }) => `${current}/${total} kapitel avklarade`,
  }),
};
